import { FC } from 'react'
import { StyleSheet, View } from 'react-native'
import CustomerInfoDialog from './dialogs/CustomerInfo/CustomerInfoDialog'
import LogoutDialog from './dialogs/LogoutDialog'
import MyAppBar from './MyAppBar/MyAppBar'
import OrderBar from './OrderBar/OrderBar'
import OrderColumns from './OrderColumns/OrderColumns'

const Digibon: FC = () => {
    return (
        <View style={styles.container}>
            <MyAppBar />
            <OrderBar />
            <OrderColumns />
            <CustomerInfoDialog />
            <LogoutDialog />
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
    },
})

export default Digibon
